import { useCallback, useState } from "react"

import { Dialog } from "@trueskin-web/components"
import i18next from "@trueskin-web/translations"

const useConfirm = () => {
  const [promise, setPromise] = useState(null)

  const confirm = () =>
    new Promise((resolve) => {
      setPromise({ resolve })
    })

  const handleClose = useCallback(() => {
    setPromise(null)
  }, [])

  const handleConfirm = useCallback(() => {
    promise?.resolve(true)
  }, [promise])

  const handleCancel = useCallback(() => {
    promise?.resolve(false)

    handleClose()
  }, [promise, handleClose])

  const ConfirmationDialog = useCallback(
    ({
      primaryActionLabel = i18next.t("Button.continue"),
      secondaryActionLabel = i18next.t("Button.cancel"),
      isLoading,
      className,
      ...props
    }) =>
      promise !== null ? (
        <Dialog
          onDismiss={handleClose}
          primaryAction={handleConfirm}
          primaryActionLabel={primaryActionLabel}
          secondaryAction={handleCancel}
          secondaryActionLabel={secondaryActionLabel}
          isPrimaryActionLoading={isLoading}
          isSecondaryActionDisabled={isLoading}
          className={className}
          {...props}
        />
      ) : null,
    [promise, handleCancel, handleConfirm, handleClose]
  )

  return [ConfirmationDialog, confirm, handleClose]
}

export default useConfirm
